<template>
  <div></div>
</template>
<script>
import $ from "jquery";
import "block-ui";
export default {
  name: "BlockUI",
  data(){
    return {
      puntos:'...'
    }
  },
  props: ['mensaje'],
  mounted() {
    let html = `
        <div class="loader">
          <div class="ball-pulse-sync">
                <div class="bg-success"></div>
                <div class="bg-success"></div>
                <div class="bg-success"></div>
            </div>
          <h4>${(this.mensaje) ? this.mensaje : 'Cargando'}${this.puntos}</h4>
        </div>`;
    let css = {
      backgroundColor: "transparent",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border:'none'
    };
    $.blockUI({
      message: html,
      css: css
    });
    // setInterval(()=>{
    //   if(this.puntos.length == 3){
    //     this.puntos = ".";
    //   }else{
    //     this.puntos += ".";
    //   }
    // },5)
  },
  destroyed() {
    $.unblockUI();
  }
};
</script>
<style>
/* .blockPage .loader {
  background: transparent !important;
  box-shadow: none !important;
} */
.loader h4{
  margin-top: 25px;
  margin-bottom:0;
  font-size: 1.2rem;
}
</style>